import { PractitionersSearchResult } from '~/api';
import { AvailabilityFilters } from './constants';

export interface Location {
  isWithinSupportedArea?: boolean;
  coordinates?: Coordinates;
  value: string;
}

export interface Coordinates {
  lat: number;
  lng: number;
}

export type ComboBoxPrediction = {
  label: string;
  value: string;
  isUseCurrentLocation?: boolean;
  geocoded?: {
    coordinates: { lat: number; lng: number };
    formattedAddress?: string;
    isWithinSupportedArea?: boolean;
  };
};

export type AvailabilityOption = {
  label: string;
  value: AvailabilityFilters;
};

export type IsMulti = false;

export enum ErrorLevel {
  Error = 'error',
  Warning = 'warning',
}

export interface ErrorLogProps {
  type: ErrorLevel;
  message: string;
}

export type SearchResultGroupByLocation = {
  clinicLocationGuid: string;
  clinicName: string;
  practitioners: PractitionersSearchResult[];
  locationCoordinates: PractitionersSearchResult['locationCoordinates'];
  streetAddress2?: string;
  streetAddress?: string;
  city?: string;
  province?: string;
  phone?: string;
  bookingUrl?: string;
};

export type InputErrorMessage = {
  type: ErrorLevel;
  message: string;
  userMessage: string;
};
